module.exports = __webpack_public_path__ + "static/media/abdata-paywall-header.dd1901b7.png";